(function() {
  const canvas = document.getElementById('bubble-canvas');
  const ctx = canvas.getContext('2d');
  let W, H;
  function resize() { W = canvas.width = window.innerWidth; H = canvas.height = window.innerHeight; }
  resize();
  window.addEventListener('resize', resize);
  let mx = 0, my = 0, distAccum = 0;
  function lerp(a, b, t) { return a + (b - a) * t; }
  const bubbles = [];
  function spawnBubble(x, y, vx, vy) {
    const speed = Math.sqrt(vx*vx+vy*vy)||1;
    const nx=vx/speed, ny=vy/speed, px=-ny, py=nx;
    const side = Math.random()<0.5?1:-1;
    const scatter = (Math.random()*1.8+0.6)*side;
    bubbles.push({ x, y, vx: vx*0.18+px*scatter*1.1+(Math.random()-0.5)*0.6, vy: vy*0.18+py*scatter*1.1+(Math.random()-0.5)*0.6, r: 7+Math.random()*8, life: 1, decay: 0.012+Math.random()*0.01, wobble: Math.random()*Math.PI*2 });
    if (bubbles.length > 5) bubbles.shift();
  }
  function drawBubble(x, y, r, alpha) {
    ctx.save(); ctx.globalAlpha = alpha * 0.85;
    ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.fillStyle='rgba(55,138,221,0.08)'; ctx.fill();
    ctx.strokeStyle='rgba(76,194,220,0.85)'; ctx.lineWidth=1; ctx.stroke();
    ctx.beginPath(); ctx.arc(x-r*0.3,y-r*0.32,r*0.22,0,Math.PI*2); ctx.fillStyle='rgba(255,255,255,0.5)'; ctx.fill();
    ctx.restore();
  }
  function frame() {
    requestAnimationFrame(frame);
    ctx.clearRect(0,0,W,H);
    for(let i=bubbles.length-1;i>=0;i--) {
      const b=bubbles[i];
      b.wobble+=0.04; b.vx+=Math.sin(b.wobble*1.3)*0.04; b.vy+=Math.sin(b.wobble)*0.03-0.04;
      b.vx*=0.97; b.vy*=0.97; b.x+=b.vx; b.y+=b.vy; b.life-=b.decay;
      if(b.life<=0){bubbles.splice(i,1);continue;}
      drawBubble(b.x,b.y,b.r,b.life);
    }
  }
  window.addEventListener('mousemove', e => {
    const dx=e.clientX-mx, dy=e.clientY-my; mx=e.clientX; my=e.clientY;
    distAccum+=Math.sqrt(dx*dx+dy*dy);
    while(distAccum>18){distAccum-=18; spawnBubble(mx,my,dx,dy);}
  });
  frame();
})();